import React from "react"
import {BrowserRouter as Router, Route, Switch, Redirect} from "react-router-dom"
import Sidebar from "react-sidebar";
import Clientlist from "./pages/clients/listClients.js"
import Campaignlist from "./pages/campaigns/listCampaign.js"
import CampaignHome from "./pages/campaigns/campaignHome.js"
import AddCampaign from "./pages/campaigns/overview.js"
import Homepage from "./pages/home/homePage.js"
import Logout from "./_helpers/logout.js"
import PrivateRoute from "./_helpers/privateRoute.js"
import logo from "./resources/images/Logo_White@small.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome, faThList, faSignOutAlt, faCog } from '@fortawesome/free-solid-svg-icons'
import AddClientForm from "./pages/clients/addClient.js"
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Link as RouterLink } from 'react-router-dom';
import parseQuery from './_helpers/query_helper.js'
import Account from "./pages/campaigns/accounts/account.js";
import SecondaryAccounts from "./pages/campaigns/accounts/secondaryAccounts.js";
import ClientAudience from "./pages/clients/clientAudience.js"

const breadcrumbNameMap = {
    '/': [],
    '/clients': ['Clients'],
    '/clients/add': ['Clients', 'Add Client'],
    '/clients/audience': ['Clients', 'Add Client'],
    '/clients/add-audience': ['Clients', 'Add Client Audience'],
    '/campaigns': ['Clients','Campaigns'],
    '/campaignGroup': ['Clients', 'Campaigns', 'Add Campaign'],
    '/campaignGroup/addCampaign': ['Clients', 'Campaigns', 'Add Campaign'],
    '/campaignGroup/audience' : ['Clients', 'Campaigns', 'Add Campaign'],
    '/campaignGroup/placement' : ['Clients', 'Campaigns', 'Add Campaign'],
    '/campaignGroup/accounts': ['Clients', 'Campaigns', 'Add Campaign'],
    '/campaignGroup/metrics': ['Clients', 'Campaigns', 'Add Campaign'],
    '/campaignGroup/ads': ['Clients', 'Campaigns', 'Add Campaign'],
    '/campaignGroup/budget': ['Clients', 'Campaigns', 'Add Campaign'],
    '/campaignGroup/publish': ['Clients', 'Campaigns', 'Add Campaign'],
    '/campaignGroup/overview': ['Clients', 'Campaigns', 'Add Campaign'],
    '/campaign/account': ['Clients', 'Campaigns', 'Edit Campaign', 'Account Details'],
    '/campaign/secondary-accounts': ['Clients', 'Campaigns', 'Edit Campaign', 'Secondary Accounts'],
    '/settings': ['Settings'],
    '/logout': []
};

const linkMap = {
    'Clients': '/clients',
    'Campaigns': '/campaigns',
    'Edit Campaign': '/campaignGroup'
};

const titleMap = {
    '/': 'Welcome to your Advertaze Campaign Manager',
    '/clients': 'Clients',
    '/clients/add': 'Add Client',
    '/clients/audience': 'Add Client',
    '/clients/add-audience': 'Add Client Audience',
    '/campaigns': 'Campaigns',
    '/campaignGroup': 'Add Campaign',
    '/campaignGroup/addCampaign': 'Add Campaign',
    '/campaignGroup/audience': 'Add Campaign',
    '/campaignGroup/placement': 'Add Campaign',
    '/campaignGroup/accounts': 'Add Campaign',
    '/campaignGroup/metrics': 'Add Campaign',
    '/campaignGroup/ads': 'Add Campaign',
    '/campaignGroup/budget': 'Add Campaign',
    '/campaignGroup/publish': 'Add Campaign',
    '/campaignGroup/overview': 'Add Campaign',
    '/campaign/account': 'Account Details',
    '/campaign/secondary-accounts': 'Secondary Accounts',
    '/settings': 'Settings',
    '/logout': ''
};

const LinkRouter = (props) => <Link {...props} component={RouterLink} />;

const mql = window.matchMedia(`(min-width: 800px)`);

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sidebarDocked: mql.matches,
            sidebarOpen: false,
            active: "home",
        };
        
        this.mediaQueryChanged = this.mediaQueryChanged.bind(this);
        this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
    }
    

    componentWillMount() {
        mql.addListener(this.mediaQueryChanged);
        if (localStorage.getItem("active") !== null) {
            this.setState({active: localStorage.getItem("active")})
        }
    }

    componentWillUnmount() {
        mql.removeListener(this.mediaQueryChanged);
    }

    onSetSidebarOpen(open) {
        this.setState({ sidebarOpen: open });
    }

    mediaQueryChanged() {
        this.setState({ sidebarDocked: mql.matches, sidebarOpen: false });
    }

    fixQueries(fromLocation, toLocation, queries) {
        var parsed = parseQuery(queries);
        if (fromLocation.startsWith('/campaign') || fromLocation === '/clients/add') {
            if (toLocation === '/clients') {
                return '?client_id=' + parsed['client_id'];
            } else if (toLocation === '/campaigns') {

                if (parsed['client_name'] == 'undefined') {
                    return '?client_id=' + parsed['client_id'] + '&client_name=' + parsed['client_name'];
                } else {
                    return '?client_id=' + parsed['client_id'];
                }

               
            }

            if (toLocation === '/campaignGroup') {
                return '/accounts?client_id=' + parsed['client_id'] + '&campaign_id=' + parsed['campaign_id'];
            }
        }

        return '';
    }

    addOrEdit(queries, fromName) {
        if (fromName.includes('Add')) {
            if ((fromName.includes('Campaign') && queries.includes('campaign_id')) || (fromName.includes('Client') && queries !== '')) {
                return fromName.replace('Add', 'Edit');
            }
        }
        return fromName;
    }

    campaignListing(queries, fromName) {
        var key = 'client_name';
        var clientNameIndex = queries.indexOf(key) + key.length + 1;
        if (queries.indexOf('&', clientNameIndex) !== -1) {
            var clientName = queries.substring(clientNameIndex, queries.indexOf('&', clientNameIndex));
        } else {
            var clientName = queries.substring(clientNameIndex);
        }

        if (clientName == 'undefined') {
            return fromName;
        } else {
            // When pressing the back or refresh button, the url parameters aren't decoded, so they have to be decoded manually
            return fromName + ' - ' + decodeURIComponent(clientName);
        }

    }

    onCrumbClick(value) {
        if (value.includes('campaign') || value.includes('client')) {
            this.setState({active: 'clients'});
        }
        
        if (value.includes('settings')) {
            this.setState({active: 'settings'});
        }
    };
    
    generateCrumbs(location) {
        const queries = location.search;
        const from = location.pathname;
        let n_breadcrumbs = breadcrumbNameMap[from].length;
        let crumbs = [];
        for (let i = 0; i<n_breadcrumbs; i++) {
            let toQuery = this.fixQueries(from, linkMap[breadcrumbNameMap[from][i]], queries);
            let display = breadcrumbNameMap[from][i].includes("Add") ? this.addOrEdit(queries, breadcrumbNameMap[from][i]) : breadcrumbNameMap[from][i];
            i === n_breadcrumbs - 1 ?
                crumbs.push(<Typography color="textPrimary" key={linkMap[breadcrumbNameMap[from][i]] + i}>
                    {display}
                </Typography>)
                :
                crumbs.push(<LinkRouter color="inherit" to={linkMap[breadcrumbNameMap[from][i]] + toQuery} key={linkMap[breadcrumbNameMap[from][i]]} onClick={ () => this.onCrumbClick(from)}>
                    {display}
                </LinkRouter>)
        }

        return crumbs;
    }

    onSideBarNavClick = (value) => {
        this.setState({active: value});
        localStorage.setItem( 'active', value );
        switch(value) {
            case "clients" :
                this.props.history.push("/clients");
                return;
            case "settings":
                this.props.history.push("/settings");
                return;
            default: this.props.history.push("/logout")
        }
    };
    
    getTitle(pathname, queries) {
        if (titleMap[pathname].includes("Add")) {
            return this.addOrEdit(queries, titleMap[pathname]);
        } else if (titleMap[pathname].includes("Campaign") && queries.includes('client_id') && queries.includes('client_name')) {
            return this.campaignListing(queries, titleMap[pathname]);
        }
        return titleMap[pathname];
    }

    render(){
        return (
            <div className="page-container">
                <Sidebar
                    sidebar={
                        <div className="sidebar-content">
                            <div className="logo">
                                <img src={logo} width="175" onClick = {() => {this.props.history.push("/clients")}}/>
                            </div>
                            
                            <div className="sidebar-items">
                            
                                <div 
                                    className={this.state.active === "clients" ? "selected sidebar-item-wrapper" : "sidebar-item-wrapper"}  
                                    onClick={ () => this.onSideBarNavClick("clients")}
                                >
                                    <div className="sidebar-item">
                                        <FontAwesomeIcon icon={faThList} />
                                        <span>Clients</span>
                                    </div>
                                </div>
                                <div 
                                    className={this.state.active === "settings" ? "selected sidebar-item-wrapper" : "sidebar-item-wrapper"}  
                                    onClick={ () => this.onSideBarNavClick("settings")}
                                >
                                    <div className="sidebar-item">
                                        <FontAwesomeIcon icon={faCog} />
                                        <span>Settings</span>
                                    </div>
                                </div>
                                <div 
                                    className={this.state.active === "logout" ? "selected sidebar-item-wrapper" : "sidebar-item-wrapper"}  
                                    onClick={ () => this.onSideBarNavClick("logout")}
                                >
                                    <div className="sidebar-item">
                                        <FontAwesomeIcon icon={faSignOutAlt} />
                                        <span>Logout</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    docked={this.state.sidebarDocked}
                    open={this.state.sidebarOpen}
                    onSetOpen={this.onSetSidebarOpen}
                >
                    <div className="page-wrapper">
                    <div id="alert"></div>
                        <div className="page-header">
                            <div className="page-title">
                                <PrivateRoute>
                                    {({ location }) => {
                                        return (
                                            <h1>
                                                {this.getTitle(location.pathname, location.search)}
                                            </h1>
                                        );
                                    }}
                                </PrivateRoute>
                                <div className="someclass">
                                    <PrivateRoute>
                                        {({ location }) => {
                                            return (
                                                <Breadcrumbs aria-label="breadcrumb">
                                                    {this.generateCrumbs(location)}
                                                </Breadcrumbs>
                                            );
                                        }}
                                    </PrivateRoute>
                                </div>
                            </div>
                        </div>
                        <div>
                            <Switch>
                                <PrivateRoute path={["/", "/clients"]}  exact component={Clientlist} />
                                <PrivateRoute path="/clients" exact component={Clientlist} />
                                <PrivateRoute path="/campaigns" exact component={Campaignlist}/>
                                <PrivateRoute path="/campaignGroup/addCampaign" component={AddCampaign} />
                                <PrivateRoute path="/campaignGroup" component={CampaignHome} />
                                <PrivateRoute path={["/clients/add", "/clients/audience"]} component={AddClientForm} />
                                <PrivateRoute path="/clients/add-audience" component={ClientAudience} />
                                <PrivateRoute path="/campaign/account" component={Account}/>
                                <PrivateRoute path="/campaign/secondary-accounts" component={SecondaryAccounts}/>
                                <PrivateRoute path="/logout" component={Logout} />
                            </Switch>
                        </div>
                    </div>
                </Sidebar>
            </div>
        )
    }
    
}

export default Home